/** @jsx jsx */
import { jsx } from "theme-ui"
import { Link } from "gatsby"
import { SiGnuprivacyguard } from "react-icons/si"

import SocialMedia from "./social-media"

const Footer = (props, socialMediaHide) => (
  <footer
    className="site-footer"
    sx={{
      bg: "primary",
    }}
  >
      <Link to="/">
        <p>
          Fashion Consultant
        </p>
      </Link>
    <SocialMedia />

      <Link to='/privacy-policy' title="privacy-policy" className="privacy-policy">
        <SiGnuprivacyguard style={{
          color: "var(--button-alternate-color)"
        }}/>
      </Link>
  </footer>
)

export default Footer
